import { Component, Vue, Prop } from "vue-property-decorator";
import { TranslationModel } from "../../models/product";
import { appStore } from "../../store/AppModule";

@Component
export default class CarbonSavingsCompilation extends Vue {
    @Prop()
    protected carbonSavings!: number;
    @Prop()
    protected imageUrl!: string;
    private translations: TranslationModel;

    constructor() {
        super();
        this.translations = window.__finja.translations as TranslationModel;
    }

    protected getDescription(compilationText: string, kiloUnitText: string, carbonDioxideText: string) {
        return compilationText.replace("{climatesavings}",
        this.carbonSavingsFormatted + " " + kiloUnitText + " " + carbonDioxideText);
    }

    get carbonSavingsFormatted() {
        return this.carbonSavings.toLocaleString(appStore.state.culture, {maximumFractionDigits: 1, minimumFractionDigits: 1});
    }
}
